import { TThunkAction } from '../../types/redux';
import { fetchCreateTripReviewPageDataAction } from './fetchCreateTripReviewPageData';
import { setNewReviewFormOpen } from './openFormActions';

/**
 * Загружает данные для формы отзыва и открывает модалку
 */
export function fetchFormDataAndOpenModalAction(): TThunkAction<Promise<void>> {
  return async dispatch => {
    await dispatch(fetchCreateTripReviewPageDataAction());
    await dispatch(setNewReviewFormOpen());
  };
}
